<div class="modal-header">
  <div class="centered">
    <h4 class="modal-title">{{ titulo }}!</h4>
  </div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 text-modal">
      <div class="flex-box">
        <h4>{{ retornoAssessment }}</h4>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="centered">
    <button
      *ngIf="showFecharBtn"
      type="button"
      class="btn btn-border-orange pull-left"
      (click)="onClickClose()"
    >
      {{ labelFechar }}
    </button>
  </div>
</div>
